export const loginRoutePaths = {
  LOGIN: 'login',
  REGISTRATION: 'registration',
  REGISTRATION_QR: 'registration-qr',
  SCAN: 'scan',
  COOKIE_POLICY: 'cookie-policy',
  SECURITY_ADVICE: 'security-advice',
  ABOUT: 'about',
  HELP: 'help',
  MOBILE: 'mobile',
  SESSION_TIMED_OUT: 'session-timed-out'
};
